import { render } from "./CreateCompanyModal.vue?vue&type=template&id=74f27a88&scoped=true"
import script from "./CreateCompanyModal.vue?vue&type=script&lang=js"
export * from "./CreateCompanyModal.vue?vue&type=script&lang=js"

import "./CreateCompanyModal.vue?vue&type=style&index=0&id=74f27a88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f27a88"]])

export default __exports__